// ------------------------ utility ------------------------ /

getUserLanguage = function () {
    let userLang = navigator.language;
    userLang = userLang.slice(0, 2)

    return userLang
}

stringToSlug = function (str) {
    return str
        .toLowerCase() // convert string to lowercase
        .replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
        .replace(/^\s+|\s+$/g, '') // trim leading/trailing white space
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, '-') // remove consecutive hyphens
}

// ------------------------ form ------------------------ //

isEmailAddress = function (string) {
    const regexMatch = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/

    return !!string.match(regexMatch)
}

isAlphaString = function (string) {
    const regexMatch = /^[a-zA-Z\s]+$/

    return !!string.match(regexMatch)
}

isPhone = function (string) {
    const regexMatch = /^(\+\d{1,2}\s)?\(?[23456789]\d{2}\)?[\s.-]\d{3}[\s.-]\d{4}/

    return !!string.match(regexMatch)
}

keyCodeIgnore = function (event) {
    const key = event.keyCode

    return ((key === 13) || (key === 229) || (key > 36 && key < 41) // left, up, right, down
    )
}

upKeyCodePhone = function (event) {
    const key = event.keyCode

    return ((key >= 48 && key <= 57) || // Allow number line
        (key >= 96 && key <= 105) || // Allow number pad
        (key === 189) || // Allow -
        (event.shiftKey === true || key === 35 || key === 36) || // Allow Shift, Home, End
        (key === 8 || key === 9 || key === 13 || key === 46) || // Allow Backspace, Tab, Enter, Delete
        (key > 36 && key < 41) || // Allow left, up, right, down
        (// Allow Ctrl/Command + A,C,V,X,Z,R
            (event.ctrlKey === true || event.metaKey === true) && (key === 65 || key === 67 || key === 86 || key === 88 || key === 90 || key === 82)))
}

formatKeyCodePhone = function (event) {
    const key = event.keyCode

    return ((key >= 48 && key <= 57) || // Allow number line
        (key >= 96 && key <= 105) || // Allow number pad
        (key === 189) || // Allow -
        (key === 8 || key === 46) || // Allow Backspace, Delete
        (// Allow Ctrl/Command + V,X,Z
            (event.ctrlKey === true || event.metaKey === true) && (key === 86 || key === 88 || key === 90)))
}

formatToPhone = (event) => {
    let caretPosition = event.target.selectionStart
    let inputRawLength = event.target.value.length

    const input = event.target.value.replace(/\D/g, '').substring(0, 10)
    const first = input.substring(0, 3)
    const middle = input.substring(3, 6)
    const last = input.substring(6, 10)

    let inputCleanLength = input.length

    let value

    if ([8, 46].includes(event.keyCode) && inputRawLength === 3) {
        value = first
    } else if ([8, 46].includes(event.keyCode) && inputRawLength === 7) {
        value = first + '-' + middle
    } else {
        if (inputCleanLength === 3 || inputCleanLength === 6) {
            caretPosition += 1
        }

        if (inputCleanLength > 5) {
            value = first + '-' + middle + '-' + last
        } else if (inputCleanLength > 2) {
            value = first + '-' + middle
        } else {
            value = first
        }
    }

    if (inputRawLength === caretPosition && value.length > caretPosition) {
        caretPosition += 1
    }

    event.target.value = value

    event.target.setSelectionRange(caretPosition, caretPosition)
}

// ------------------------ tracking ------------------------ //

googleTriggerEvent = function (event, args) {
    window.dataLayer = window.dataLayer || []

    let vars = {
        'event': event
    }

    // Merge vars with args if args is an object
    if (args && typeof args === 'object') {
        vars = { ...vars, ...args }
    }

    window.dataLayer.push(vars)
}

setupEverflow = async function () {
    console.log('everflow - setup')

    const oid = getEverflowParameter('oid')

    let transaction_id = EF.getTransactionId(oid)

    if (transaction_id) {
        console.log('transaction found', transaction_id)
    } else {
        transaction_id = EF.click({
            offer_id: oid,
            affiliate_id: getEverflowParameter('affid'),
            sub1: getEverflowParameter('sub1'),
            sub2: getEverflowParameter('sub2'),
            sub3: getEverflowParameter('sub3'),
            sub4: getEverflowParameter('sub4'),
            sub5: getEverflowParameter('sub5'),
            uid: getEverflowParameter('uid'),
            source_id: getEverflowParameter('source_id'),
            transaction_id: getEverflowParameter('_ef_transaction_id'),
            parameters: {
                fbclid: getEverflowParameter('fbclid'),
                ttclid: getEverflowParameter('ttclid'),
                gclid: getEverflowParameter('gclid'),
            },
        })

        console.log('transaction create', transaction_id)
    }

    setTransactionId(transaction_id)

    return transaction_id
}

getEverflowParameter = function (key) {
    // Get value by URL parameter and if it doesn't exist look for cookie value
    let value = EF.urlParameter(key) || readCookie(key)

    // If value is not present use default values
    if (!value) {
        switch (key) {
            case 'oid':
                value = trackingConfig.default.oid ?? ''
                break
            case 'affid':
                value = trackingConfig.default.affid ?? ''
                break
            case 'source_id':
                value = trackingConfig.default.source_id ?? ''
                break
        }
    }

    // For selected keys add cookie
    if (value && ['oid', 'affid', 'sub3', 'sub4', 'sub5'].includes(key) === true) {
        setCookie(key, value, 86400)
    }

    return value
}

setTransactionId = function (transaction_id) {
    console.log(transaction_id)

    document.querySelectorAll('input[name="transaction_id"]').forEach((input) => {
        input.value = transaction_id
    })
}

// ------------------------ functionality ------------------------ //

setupNavMenu = function () {
    document.querySelector('#nav-menu-open').addEventListener('click', function () {
        document.querySelector('#nav-menu-open').style.display = 'none'
        document.querySelector('#nav-menu-close').style.display = 'block'
        document.querySelector('#nav-menu').classList.add('open')
    })

    document.querySelector('#nav-menu-close').addEventListener('click', function () {
        document.querySelector('#nav-menu-open').style.display = 'block'
        document.querySelector('#nav-menu-close').style.display = 'none'
        document.querySelector('#nav-menu').classList.remove('open')
    })
}

setLicenseNum = function(string) {
    document.querySelector('#license-num').textContent = string
}

setupFormCta = function() {
    // Return `true` on error
    function checkPostalCode(inputPostalCode) {
        if (inputPostalCode.value.length !== 5 || inputPostalCode.value === '00000') {
            // Mark as invalid
            toggleValid(inputPostalCode, false)

            return true
        } else {
            // Mark as valid
            toggleValid(inputPostalCode, true)

            return false
        }
    }

    document.querySelectorAll('.lead-cta').forEach((formElement) => {
        const checkData = formElement.dataset.check === 'true'

        let inputPostalCode = formElement.querySelector('input[name="postal_code"]')

        if (checkData === true) {
            inputPostalCode.addEventListener('keyup', async (event) => {
                if (keyCodeIgnore(event) === true) {
                    return
                }

                checkPostalCode(inputPostalCode)
            })

            inputPostalCode.addEventListener('change', async () => {
                checkPostalCode(inputPostalCode)
            })
        }

        formElement.addEventListener('submit', function (e) {
            e.preventDefault()

            let hasError = false

            if (checkData === true) {
                hasError = checkPostalCode(inputPostalCode)
            }

            if (hasError === false) {
                const button = formElement.querySelector('button[type="submit"]')

                // Mark as loading
                button.setAttribute('disabled', 'disabled')
                button.innerHTML = returnButtonProcessing()

                // Submit
                formElement.submit()
            }
        })
    })
}

setupEbookCta = function() {
    document.querySelectorAll('.ebook-cta').forEach((formElement) => {
        formElement.addEventListener('submit', function (e) {
            e.preventDefault()

            const button = formElement.querySelector('button[type="submit"]')

            // Mark as loading
            button.setAttribute('disabled', 'disabled')
            button.innerHTML = returnButtonProcessing()

            // Submit
            formElement.submit()
        })
    })
}

setupModalEbook = function() {
    let modalElement = document.querySelector('#modalEbook')

    // If modal element is not found > do nothing
    if (modalElement === null) {
        return
    }

    // Function handling modal display
    function showModal(modalElement) {
        // Set cookie which prevents modal display for next 30 minutes
        // This cookie is also set in the `form-ebook.js` > `handleFormSubmit` for production
        setCookie('statusModalEbook', 1, 1800)

        modalElement.style.display = 'block'

        modalElement.querySelector('#modal-ebook-close').addEventListener('click', function (e) {
            modalElement.style.display = 'none'
        })
    }

    // Force modal display if GET param present
    if (getQueryParam('forceModal') === 'true') {
        showModal(modalElement)

        return
    }

    let statusModalEbook = readCookie('statusModalEbook') ?? null

    if (statusModalEbook === null) {
        if (isViewportMobile() === true) {
            setTimeout(() => {
                showModal(modalElement)
            }, 60000)
        } else {
            // Bind
            document.addEventListener('mouseleave', function (event) {
                if (statusModalEbook === null && event.clientY < 0) {
                    showModal(modalElement)

                    statusModalEbook = 1 // We do this because the cookie is not read inside the event listener
                }
            })
        }
    }
}

setupArticle = function() {
    const stickyMobileContent = document.querySelector('#sticky-mobile-content')
    const stickyDesktopUl = document.querySelector('#sticky-desktop-ul')

    // Create table contents links based on article content <h2>
    document.querySelectorAll('.article-content h2').forEach((contentElement, contentNumber) => {
        const liText = contentElement.textContent
        const liAnchor = stringToSlug(liText)
        const liHtml =
            '<a href="#' + liAnchor + '" title="' + liText + '">' +
                liText +
            '</a>'

        // Mark headline with id attribute
        contentElement.id = liAnchor

        let liDesktopElement = document.createElement('li')
            liDesktopElement.id = 'stc-' +  (contentNumber + 1)
            liDesktopElement.innerHTML = liHtml

        stickyDesktopUl.appendChild(liDesktopElement)

        let liMobileElement = document.createElement('li')
            liMobileElement.innerHTML = liHtml

        stickyMobileContent.querySelector('#sticky-mobile-ul').appendChild(liMobileElement)
    })

    // Bind table contents links (note: there is some sort of bug / issue on first click on a anchor link without this)
    document.querySelectorAll('.sticky-ul a').forEach((linkElement) => {
        linkElement.addEventListener('click', function(e) {
            e.preventDefault()

            smoothScrollingTo(this.getAttribute('href'), 48)
        })
    })

    // Bind functionality for mobile table contents
    stickyMobileContent.querySelector('#sticky-mobile-title').addEventListener('click', function() {
        stickyMobileContent.classList.toggle('collapsed')
    })

    stickyMobileContent.querySelectorAll('#sticky-mobile-ul a').forEach((element) => {
        element.addEventListener('click', function() {
            stickyMobileContent.classList.remove('collapsed')
        })
    })

    function debounce(func, delay) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
        };
    }

    const is_viewport = window.matchMedia('(max-width: 1023px)').matches

    window.onscroll = debounce(function () {
        let y = window.scrollY
        let selectedContentNumber

        document.querySelectorAll('.article-content h2').forEach((contentElement, contentNumber) => {
            contentNumber = contentNumber + 1

            document.querySelector('#stc-' + contentNumber).classList.remove('is-selected')

            if (y > contentElement.offsetTop - 150) {
                selectedContentNumber = contentNumber
            }
        })

        if (selectedContentNumber) {
            document.querySelector('#stc-' + selectedContentNumber).classList.add('is-selected')
        }

        if (is_viewport === true) {
            if(y > stickyMobileContent.offsetTop) {
                stickyMobileContent.style.position = 'fixed'
            } else {
                stickyMobileContent.style.position = 'static'
            }
        }
    }, 100)

    smoothScrollingTo(window.location.hash, 48)
}
